<template>
  <div>
    <Breadcrumb :dataSource="breadcrumbList" />
    <div class="page-container" style="padding-top: 0">
      <a-tabs v-model="tabKey" @change="handleTabChange">
        <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
          <TableList
            :columns="columns"
            :tableData="dataSource"
            bordered
            :loading="loading"
            :scroll="{}"
            :pagination="ipagination"
            @change="handleTableChange"
            style="min-height: 350px"
          >
            <div slot="queryArea" class="query-area">
              <div>
                <j-dict-select-tag
                  style="width: 170px; margin-right: 15px"
                  placeholder="请选择年级"
                  v-model="queryParam.gradeId"
                  dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                  :isShowEmpty="false"
                  @select="$set(queryParam, 'classId', undefined)"
                  @clear="$set(queryParam, 'classId', undefined)"
                />
                <j-dict-select-tag
                  style="width: 170px; margin-right: 15px"
                  placeholder="请选择班级"
                  v-model="queryParam.classId"
                  :dictCode="
                    'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                  "
                  :async="true"
                  :disabled="!queryParam.gradeId"
                  :isShowEmpty="false"
                />
                <!--<a-range-picker v-model="dateRange" class="search-space" style="width: 240px" />-->
                <a-input-search
                  v-model="queryParam.studentName"
                  placeholder="请输入学生名字"
                  class="search-space"
                  style="width: 170px"
                  @change="searchName"
                />
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 15px"
                >
                  重置
                </a-button>
              </div>
              <a-button
                type="primary"
                icon="download"
                :loading="exportXlsLoading"
                style="margin-left: auto"
                @click="handleExportXls(item.tab)"
              >
                导出
              </a-button>
            </div>
            <span slot="continuously" slot-scope="{ record }" class="continuously">
              {{ record.continuously }}
            </span>
            <span slot="careList_dictText" slot-scope="{ record }" class="careList-dictText">
              {{ record.careList_dictText }}
            </span>
            <div class="flex-align-center" slot="labelsList" slot-scope="{ record }">
              <span
                v-for="(item, index) in record.labelsList"
                :key="index"
                :style="{
                  color: getStuTagColorConfig(item.key).color,
                  background: getStuTagColorConfig(item.key).bgColor,
                }"
                class="label-item"
              >
                {{ item.text }}
              </span>
            </div>
            <span slot="hasWarnThisWeek" slot-scope="{ record }">
              <img
                v-if="record.hasWarnThisWeek == 1"
                src="@/assets/imgs/commonPage/remind.png"
                alt=""
                style="width: 20px; height: 20px"
              />
              <span v-else>未提醒</span>
            </span>
            <template slot="action" slot-scope="{ record }">
              <div class="action-detail">
                <!-- <template v-if="identityId == 6">
                  <span @click="viewTutorRecord(record)">添加干预记录</span>
                  <a-divider type="vertical" />
                </template> -->
                <span @click="viewArchives(record)" class="action-span">查看档案</span>
                <span @click="addLedger(record)" class="action-span">添加台账</span>
                <span @click="addVisitRecord(record)" class="action-span">添加家访记录</span>
              </div>
            </template>
          </TableList>
        </a-tab-pane>
      </a-tabs>
      <AddLedgerModal ref="addLedgerModalRef" @refreshData="loadData" />
      <AddInterveneRecord ref="interveneRecordRef" @refreshData="loadData" />
      <!-- 添加家访记录 -->
      <AddVisitRecordModal ref="visitRecordModalRef" @refreshData="loadData" />
    </div>
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { getStuTagColorConfig, simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal'
import AddInterveneRecord from '@/comUi/AddInterveneRecord'
import Breadcrumb from '@/components/Breadcrumb/index'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import AddLedgerModal from '@/views/school/mentalHealth/TutorStandBook/components/StudentTutor/components/AddLedgerModal'
import AddVisitRecordModal from '@/views/school/mentalHealth/CrisisIntervent/components/AddVisitRecordModal'
import { mapGetters } from 'vuex'

export default {
  name: 'MainCareStuOverview',
  components: {
    TableList,
    AssessModal,
    AddInterveneRecord,
    Breadcrumb,
    AddLedgerModal,
    AddVisitRecordModal
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      breadcrumbList: [
        {
          label: '心理工作概览',
          isBack: true,
        },
        {
          label: '重点关爱学生概览',
        },
      ],
      tabKey: 1,
      queryParam: {
        // type: 0,
        // name: '',
      },
      dateRange: [],
      // tab列表配置
      tabPaneConfig: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '学生标签',
          dataIndex: 'labelsList',
          align: 'center',
          scopedSlots: { customRender: 'labelsList' },
        },
        {
          title: '本周提醒',
          dataIndex: 'hasWarnThisWeek',
          align: 'center',
          scopedSlots: { customRender: 'hasWarnThisWeek' },
        },
        {
          title: '本学期提醒次数',
          dataIndex: 'semesterWarnNum',
          align: 'center',
        },
        {
          title: '本学期辅导次数',
          dataIndex: 'processedWarnNum',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/statisticV2/getKeyStudentsByCategory',
        exportXlsUrl: '/statisticV2/exportKeyStudentsXls',
      },
      detailModalData: [],
      disableMixinCreated: true,
    }
  },
  created() {
    const currTabKey = this.$route.query?.index
    if (currTabKey) {
      this.tabKey = Number(currTabKey)
    }
    this.queryParam.type = this.tabKey
    this.getKeyStudent().then(() => {
      this.loadData(1)
    })
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    ...mapGetters(['identityId']),
  },
  methods: {
    getStuTagColorConfig,
    addLedger(row){
      this.$refs.addLedgerModalRef.showModal({
        gradeId:row.gradeId,
        classId:row.classId,
        studentId:row.studentId
      },"append")
    },
    // 添加家访记录
    addVisitRecord(row) {
      this.$refs.visitRecordModalRef.showModal(
        {
          gradeId: row.gradeId,
          classId: row.classId,
          studentId: row.studentId,
        },
        'append'
      )
    },
    async getKeyStudent() {
      const res = await getAction('/statisticV2/getKeyStudent')
      const { success, result } = res
      if (success) {
        this.tabPaneConfig = result
      }
    },
    handleTabChange(key) {
      this.queryParam = {}
      this.tabKey = key
      this.queryParam.type = key
      this.loadData(1)
    },
    searchName: simpleDebounce(function (event) {
      this.queryParam.studentName = event.target?.value
      this.loadData(1)
    }, 800),
    // 重置
    searchReset() {
      this.queryParam = {}
      this.queryParam.type = this.tabKey
      this.loadData(1)
    },
    viewTutorRecord(record) {
      this.$refs.interveneRecordRef.showModal(record)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}

.search-space {
  width: 140px;
  margin-right: 15px;
}

.label-item {
  margin: 0 4px;
  padding: 2px 8px;
  color: #575757;
  background-color: #fafafa;
  border-radius: 12px;
}
.action-span{
  display: inline-block;
  margin-right: 10px;
  color: #0077fa;
}
</style>
